import React from "react";

export default function SectionHeader({ kicker, title, sub, light = false, center = true }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-2xl reveal`}>
      {kicker && (
        <span className={`inline-block text-sm font-bold tracking-[0.18em] uppercase ${light ? "text-accent" : "text-primary"}`}>
          {kicker}
        </span>
      )}
      <h2 className={`mt-3 font-display font-extrabold text-3xl md:text-4xl leading-tight ${light ? "text-white" : "text-foreground"}`}>
        {title}
      </h2>
      {sub && (
        <p className={`mt-4 text-base md:text-lg ${light ? "text-white/80" : "text-muted-foreground"}`}>
          {sub}
        </p>
      )}
    </div>
  );
}
